// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3sU7C","name":"styles_name__3OoTo","phone":"styles_phone__3FKoY"};